<template>
	<!-- 企业通知管理 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.title" placeholder="通知标题"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getNoticeList">查询</el-button>
				</el-form-item>
				<el-form-item  v-if="!comuser" >
					<el-button  type="success" @click="handleAdd">发布通知</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="noticelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="title" label="标题" min-width="200" align="center">
			</el-table-column>

			<el-table-column prop="userName" label="发布人" align="center"  min-width="100">
			</el-table-column>

			<el-table-column prop="createTime" label="发布时间" min-width="100" align="center">
			</el-table-column>

	 		<el-table-column v-if="!comuser" label="通知类型" align="center" min-width="80" >
				<template slot-scope="scope">
				<span>{{scope.row.noticeType==='0'?'全部企业':"指定企业"}}</span>
				</template>
			</el-table-column>

			<el-table-column v-if="comuser" label="通知状态" align="center" min-width="80" >
				<template slot-scope="scope">
					<div v-if='scope.row.readStatus==="0"'>
						<span style="color: red;">未读</span>
					</div>
					<div v-else>
						<span>已读</span>
					</div>
				</template>
			</el-table-column>

			<el-table-column   label="操作" align="left" width="300">
				<template slot-scope="scope">
					<el-button  v-if="!comuser" type="info" size="small" @click="handleDetail(scope.$index, scope.row)">通知详情</el-button>
					<el-button  v-if="!comuser" type="success" size="small" @click="handleCompanyDetail(scope.$index, scope.row)">签收详情</el-button>
					<el-button  v-if="!comuser" type="danger" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
					<el-button  v-if="comuser" type="success" size="small" @click="handleDetail(scope.$index, scope.row)">查看通知</el-button>
					<el-button  v-if="comuser" type="primary" size="small" @click="handleCompanyfileAdd(scope.$index, scope.row)">上传附件</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增通知信息-->
		<el-dialog title="新增通知信息" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item label="标题" prop="title">
					<el-input v-model="addForm.title" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="内容" prop="content">
					<el-input  type="textarea" :rows="5" v-model="addForm.content" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="通知类型" >
					<el-select v-model="addForm.noticeType" placeholder="请选择">
						<el-option v-for="item in ntoptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<!-- 指定企业时，勾选表格（1显示） -->
				<el-form-item label="接收企业" v-if="addForm.noticeType == '1'" >
					<el-table :data="enterpriseList" border style="width: 100%;" max-height="250" @selection-change="handleEnterpriseSelect">
						<el-table-column type="selection" width="55" />
						<el-table-column prop="coName" label="企业名称" />
						<!-- <el-table-column prop="coHeadName" label="企业编码" /> -->
					</el-table>
				</el-form-item>

				<!-- 多附件上传（支持类型:accept="'.pdf,.doc,.docx,.xls,.xlsx'"）   -->
				<el-form-item label="通知附件">
					<el-upload action="/yhpczl/mgr/v1/notice/upload" :multiple="true"
					  	:on-preview="handlePreview" :on-remove="handleRemove" :auto-upload="false"
						:accept="'.pdf'" :on-success="handleAttachmentSuccess" ref="upload">
						<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
						<el-button size="small" type="success" @click="submitUpload">点击上传</el-button>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handleNoticeAdd" :loading="addLoading">发布通知</el-button>
			</div>
		</el-dialog>


		<!--企业按通知要求，提交材料给管局-->
		<el-dialog title="企业提交材料" v-model="editFormVisible" :close-on-click-modal="false">
      		<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">	
				<el-form-item label="通知标题" prop="title">
					<span>{{editForm.title}}</span>
				</el-form-item>

				<!-- 多附件上传（支持类型:accept="'.pdf,.doc,.docx,.xls,.xlsx'"） -->
				<el-form-item label="企业材料">
					<el-upload action="/yhpczl/mgr/v1/notice/upload" :multiple="true"
					  	:on-preview="handlePreview" :on-remove="handleRemove" :auto-upload="false" 
						:accept="'.pdf'" :on-success="handleAttachmentSuccess" ref="upload">
						<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
						<el-button size="small" type="success" @click="submitUpload">点击上传</el-button>
					</el-upload>
				</el-form-item>
      		</el-form>
      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">关闭</el-button>
				<el-button type="primary" @click.native="updateCompanyfile" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="通知详情" v-model="detailFormVisible" :close-on-click-modal="false">
			<h2 class="base-name">{{ detailForm.title }}</h2>
			<div class="base-info-row">
				<div class="info-item">
					<span class="label">发布人：</span>  
					<span class="value">{{detailForm.userName}}</span>
				</div>
				<div class="info-item">
					<span class="label">发布时间：</span>
					<span class="value">{{detailForm.createTime}}</span>
				</div>	
				<div class="info-item">
					<span class="label">通知内容：</span>
					<span class="value">{{detailForm.content}}</span>
				</div>	
			</div>
			<div v-if="detailForm.fileurls.length>0">
				<h3 >通知附件</h3>
				<el-table :data="detailForm.fileurls" border style="width: 100%;" >
					<el-table-column prop="fileName" label="文件名称" />
					<el-table-column label="操作"  align="left" width="100">
						<template slot-scope="scope">
							<el-button type="primary" size="small" @click="handleFileShow(scope.$index, scope.row)">查看文件</el-button>
						</template>
					</el-table-column>
					
				</el-table>
			</div>
			<div v-if="comuser&&detailForm.comfileurls.length>0">
				<h3 >企业资料</h3>
				<el-table :data="detailForm.comfileurls" border style="width: 100%;" >
					<el-table-column prop="fileName" label="文件名称" />
					<el-table-column label="操作"  align="left" width="100">
						<template slot-scope="scope">
							<el-button type="primary" size="small" @click="handleFileShow(scope.$index, scope.row)">查看文件</el-button>
						</template>
					</el-table-column>
					
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="detailFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog title="通知签收详情" v-model="comdetailFormVisible" :close-on-click-modal="false">
			<h2 class="base-name">{{ comdetailForm.title }}</h2>
			<div class="base-info-row">
				<div class="info-item">
					<span class="label">应签收企业数：</span>  
					<span class="value">{{comdetailForm.totalcount}}</span>
				</div>
				<div class="info-item">
					<span class="label">已签收企业数：</span>
					<span class="value">{{comdetailForm.readcount}}</span>
				</div>	
			</div>

			<h3 >企业签收情况表</h3>
			<el-table :data="comdetailForm.nclist" border style="width: 100%;" max-height="250">
				<el-table-column prop="coName" label="企业名称" />
				<el-table-column label="签收状态" align="center" >
					<template slot-scope="scope">
						<div v-if='scope.row.readStatus==="0"'>
							<span style="color: red;">未读</span>
						</div>
						<div v-else>
							<span>已读</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="企业材料"  align="center">
					<template slot-scope="scope">
						<el-button v-if='scope.row.readStatus==="1"' type="primary" size="small" @click="handleShowComfile(scope.$index, scope.row)">查看材料</el-button>
					</template>
				</el-table-column>
				
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="comdetailFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog title="企业资料" v-model="comdetailfileFormVisible" :close-on-click-modal="false">
			<div class="info-item">
				<span class="label">企业名称：</span>  
				<span class="value">{{comdetailfileForm.coName}}</span>
			</div>
			<el-table :data="comdetailfileForm.comfileurls" border style="width: 100%;" >
				<el-table-column prop="fileName" label="文件名称" />
				<el-table-column label="操作"  align="left" width="100">
					<template slot-scope="scope">
						<el-button type="primary" size="small" @click="handleFileShow(scope.$index, scope.row)">查看文件</el-button>
					</template>
				</el-table-column>
				
			</el-table>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="comdetailfileFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!--显示PDF-->
		<el-dialog :title="pdfFileName" v-model="pdfVisible" :close-on-click-modal="false" >
			<el-form>
				<iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 500px"></iframe>
			</el-form>
		</el-dialog>

	</section>
</template>

<script>
	import {getNoticeListPage,getcompanyNoticeListPage,addNotice,addCompanyFiles,noticeCompanyList,deleteNotice,getNoticeFileList,allCompanyList,updateNoticeCompanyStatus} from '../../api/api';
	import {fetchUnreadCount  } from '../../common/js/notificationState';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id
				
				comuser:false,//false管局，true企业

				filters: {
					title: ''
				},
				noticelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//新增企业信息
				ntoptions: [
					{
						value: '0',
						label: '全部企业'
					}, 
					{
						value: '1',
						label: '指定企业'
					}
				],
				addFormVisible: false, 
				addLoading: false,
				addFormRules: {
					title: [{ required: true, message: "请输入通知标题", trigger: "blur" }],
					content: [{ required: true, message: "请输入通知内容", trigger: "blur" }],
				},
				
				addForm: {
					createUserId:"",
					noticeType:"0",

					content:'',
					title:'',
					
					enterpriseIds: [], // 存储勾选的企业ID
					fileurls:[]
				},

				fileurls: [], // 存储上传成功的附件fileUrl,fileName
				enterpriseList: [], // 企业列表（从后端接口获取）

				//企业提交材料
				editFormVisible: false, 
				editLoading: false,
				editFormRules: {
				},
				
				editForm: {
					coId:0,
					noticeId:0,
					title: "",
					fileurls:[]
				},

				//通知详情页面
				detailFormVisible: false, 
				
				detailForm: {	
					title:'',
					content:'',
					userName:'',
					createTime:'',
					fileurls:[],
					comfileurls:[]
				},
				//企业通知签收详情页面  
				comdetailFormVisible: false, 
				
				comdetailForm: {	
					title:'',
					noticeId:0,
					totalcount:0,
					readcount:0,
					nclist:[]
				},
				
				//通知详情页面
				comdetailfileFormVisible: false, 
				
				comdetailfileForm: {	
					coName:'',
					comfileurls:[]
				},

				// 显示pdf
				pdfVisible: false, 
				pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
				pdfFileName:"",
				// 正式地址
				filebaseurl:"https://aqjg.ycsyzglj.com/",
			}
		},
		methods: {
			handleCurrentChange(val) {				
				this.page = val;
				this.getNoticeList();
			},
			//按类型获取通知列表
			getNoticeList() {
				if (this.comuser) {
					let para = {
						page: this.page,
						pageSize:20,
						coId:this.coId,
						title: this.filters.title,
					};
					this.listLoading = true;
					getcompanyNoticeListPage(para).then((res) => {
						if(res.data.code==0){
							this.total = res.data.data.total;
							this.noticelist = res.data.data.list;
						}
						this.listLoading = false;
					});
				} else {
					let para = {
						page: this.page,
						pageSize:20,
						objectId:this.objectId,
						title: this.filters.title,
					};
					this.listLoading = true;
					getNoticeListPage(para).then((res) => {
						if(res.data.code==0){
							this.total = res.data.data.total;
							this.noticelist = res.data.data.list;
						}
						this.listLoading = false;
					});
				}
			},
			
			//新增通知
			handleAdd: function () {
				if(this.enterpriseList.length==0){
					this.$message.error("请先创建企业");
				}else{
					this.addFormVisible = true,
					this.addForm.createUserId=this.objectId,
					this.addForm.noticeType="0", //默认全部企业
					this.addForm.content='',
					this.addForm.title='',
					this.addForm.enterpriseIds=[] // 存储勾选的企业ID
					
					this.addForm.fileurls=[]

					if (this.fileurls.length!=0) {
						// 调用clearFiles()清空文件列表
						this.$refs.upload.clearFiles();
						this.fileurls=[]
					}
				}	
			},
			handleNoticeAdd() { 
				if (this.addForm.noticeType=="1"&&this.addForm.enterpriseIds.length==0) {
					this.$message.error("请选择接收通知的企业");
				} else {
					this.addForm.fileurls=this.fileurls
					this.$refs.addForm.validate((valid) => {
						if (valid) {
							this.$confirm('确认发布信息吗？', '提示', {}).then(() => {
								this.addLoading = true;

								addNotice(this.addForm).then((res) => {
									this.addLoading = false;
									this.addFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										this.getNoticeList();
									}
									else{
										this.$message.error(res.data.message);
									}
						

									});
								});	
						}
					});
				}
			},
		
			//企业提交文件
			handleCompanyfileAdd: function (index, row) {
				this.editForm.createUserId=this.coId
				this.editForm.title=row.title,
				this.editForm.noticeId=row.noticeId,
				this.editForm.fileurls=[]
				this.editFormVisible = true
				if (this.fileurls.length!=0) {
					// 调用clearFiles()清空文件列表
					this.$refs.upload.clearFiles();
					this.fileurls=[]
				}
			},
			updateCompanyfile: function () {
				this.editForm.fileurls=this.fileurls
				if(this.editForm.fileurls.length==0){
					//没选择文件直接关闭页面
					this.editFormVisible = false;
				}else{
					this.$confirm('确认提交企业文件吗？', '提示', {}).then(() => {
					this.editLoading = true;
					addCompanyFiles(this.editForm).then((res) => {
							this.editLoading = false;
							this.editFormVisible = false;
							if(res.data.code==0){
								this.$message.success(res.data.message);
								this.getNoticeList();
							}
							else{
								this.$message.error(res.data.message);
							}
						});
					});
				}		
			},	
			handleDetail: function (index, row) {
				this.detailForm.title= row.title
				this.detailForm.content= row.content
				this.detailForm.userName= row.userName
				this.detailForm.createTime= row.createTime  
				this.detailForm.fileurls=[]
				this.detailForm.comfileurls=[]
				//获取通知文件列表（文件名称，文件地址）
				let para = {
					createUserId:"",
					fileType:"0",
					noticeId: row.noticeId,
				};

				getNoticeFileList(para).then((res) => {
					if(res.data.code==0){
						this.detailForm.fileurls = res.data.data;
						
						if (this.comuser) {
							let para = {
								createUserId:this.coId,
								fileType:"1",
								noticeId: row.noticeId,
							};
							getNoticeFileList(para).then((res) => {
								if(res.data.code==0){
									this.detailFormVisible = true;
									this.detailForm.comfileurls = res.data.data;

									//企业用户更新通知状态
									if (row.readStatus=='0') {
										let para = {
											coId:this.coId,
											noticeId: row.noticeId,
										};
										updateNoticeCompanyStatus(para).then((res) => {
											if(res.data.code==0){
												fetchUnreadCount() //未读通知数
												this.getNoticeList();
											}
										});
									}
								}
							});
						}
						else{
							this.detailFormVisible = true;
						}
					}
				});

				
			},
			
			handleDelete: function (index, row) {
					this.$confirm('确认删除这个通知吗？', '提示', {}).then(() => {
					let deletecompanyparam={
						noticeId:row.noticeId,
						updateUserId:this.objectId,
					}
					deleteNotice(deletecompanyparam).then((res) => {
						if(res.data.code==0){
							this.$message.success(res.data.message);
							this.getNoticeList();
						}
						else{
							this.$message.error(res.data.message);
						}
					});
				});	
			},	

			
		

			//获取全部客户列表
			getAllcompanyList() {
				let para = {
					objectId:this.objectId
				};
		
				allCompanyList(para).then((res) => {
					if(res.data.code==0){
						this.enterpriseList = res.data.data;
					}
				});
			},
			// 勾选指定企业：记录企业ID
			handleEnterpriseSelect(selection) {
				this.addForm.enterpriseIds = selection.map(item => item.coId)
			},

			handleFileShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.fileUrl
				this.pdfFileName=row.fileName
				this.pdfVisible=true
			},
			submitUpload() {
				this.$refs.upload.submit();
			},
			handleRemove(file, fileList) {
				this.fileurls=[]
				for (let index = 0; index < fileList.length; index++) {
					const element = fileList[index];
					let curfileName=element.name
					let curfileUrl=''
					if(element.status=="success"){
						curfileUrl=element.response.data[0]
					}
					let filedic={
						"fileName":curfileName,
						"fileUrl":curfileUrl
					}
					this.fileurls.push(filedic)
				}

			},
			handlePreview(file) {

			},
			handleAttachmentSuccess(response,file,fileList) {
				this.fileurls=[]
				for (let index = 0; index < fileList.length; index++) {
					const element = fileList[index];
					let curfileName=element.name
					let curfileUrl=''
					if(element.status=="success"){
						curfileUrl=element.response.data[0]
					}
					let filedic={
						"fileName":curfileName,
						"fileUrl":curfileUrl
					}
					this.fileurls.push(filedic)
				}

			},
			handleCompanyDetail: function (index, row) {
				this.comdetailForm.title= row.title
				this.comdetailForm.noticeId= row.noticeId
				let para = {
					noticeId: row.noticeId,
				};

				noticeCompanyList(para).then((res) => {
					if(res.data.code==0){
						this.comdetailFormVisible = true;
						this.comdetailForm.readcount = res.data.data.readcount;
						this.comdetailForm.totalcount = res.data.data.totalcount;
						this.comdetailForm.nclist = res.data.data.nclist;
						
					}
				});
			},
			handleShowComfile: function (index, row) {
				this.comdetailfileForm.coName=row.coName
				this.comdetailfileForm.comfileurls=[]
				let para = {
					createUserId:row.coId,
					fileType:"1",
					noticeId:this.comdetailForm.noticeId,
				};
				getNoticeFileList(para).then((res) => {
					if(res.data.code==0){
						this.comdetailfileFormVisible = true;
						this.comdetailfileForm.comfileurls = res.data.data;
					}
				});				
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId

			if (user.data.roleId=="4") {
				this.comuser=true
				this.coId = user.data.coId
			} else {
				this.comuser=false
				this.getAllcompanyList();
			}
			
			this.getNoticeList();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// noticeManager.vue?5b9f0551